import {useEffect, useMemo, useState} from "react";
import {Card, Grid} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-apex chart
import BasicRadarChart from "examples/Charts/RadarChart/BasicRadarChart";

// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

const RadarChart = ({title, description, data, options, loaderState = false}) => {

  const [showloader, setShowloader] = useState(loaderState);

  useEffect(() => {
    setShowloader(loaderState);
  }, [loaderState]);


  const renderChart = (
    <VuiBox sx={{position: 'relative', display: 'inline-flex', minHeight: "120px"}}>
      {useMemo(() => (
      <Grid container width={"100%"}>
        <Grid item xs={12}>
          {title || description ? (
            <VuiBox px={description ? 1 : 0} pt={description ? 1 : 0}>
              {title && (
                <VuiBox mb={1}>
                  <VuiTypography variant="h5" textTransform="capitalize"
                    fontWeight="800"
                    color="#3b3663">
                    {title}
                  </VuiTypography>
                </VuiBox>
              )}
              <VuiBox mb={2}>
                <VuiTypography component="div" variant="button" fontWeight="regular" color="text">
                  {description}
                </VuiTypography>
              </VuiBox>
            </VuiBox>
          ) : null}
        </Grid>
        <Grid item xs={12}>
            {
              showloader ?
                <Grid item xs={12} textAlign={"center"} width={"100%"}>
                  <CircularProgress size={"4rem"} color={"white"}/>
                </Grid> :
                <VuiBox>
                  <BasicRadarChart radarChartData={data} radarChartOptions={options}/>
                </VuiBox>
            }
        </Grid>
      </Grid>
      ), [data, options, showloader])}
    </VuiBox>
  );

  return title || description ? <Card>{renderChart}</Card> : renderChart;
}

// Setting default values for the props of RadarChart
RadarChart.defaultProps = {
  title: "",
  description: "",
};

// Typechecking props for the RadarChart
RadarChart.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  options: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default RadarChart;
